/**
 * Lucide stroke in viewBox units (24), so the rendered width scales with the icon: 1.25px at 20px,
 * 1px at 16px. The sidebar sets the same value in CSS, where its icons have no call site.
 */
export const ICON_STROKE = 1.5
